import { defineMessages } from "react-intl";

export default defineMessages({
	selectAllChecbox: {
		id: "table.selectAllCheckbox",
		defaultMessage: "Velg Alle",
		description: "Label for global table checkbox"
	},
	"limitdetails.customerId": {
		id: "table.limitdetails.Customer",
		defaultMessage: "Kunde",
		description: "Label for customer"
	},
	"limitdetails.customers": {
		id: "table.limitdetails.Customers",
		defaultMessage: "Kunde",
		description: "Label for customer"
	},
	"limitdetails.objectTypes": {
		id: "table.limitdetails.ObjectTypes",
		defaultMessage: "Gjenstandsgruppe",
		description: "Label for objecttypes"
	},
	"limitdetails.limitAmount": {
		id: "table.limitdetails.LimitAmount",
		defaultMessage: "Rammebeløp",
		description: "Label for limitamount"
	},
	"limitdetails.limitApplicationNumber": {
		id: "table.limitdetails.limitApplicationNumber",
		defaultMessage: "Rammesøknad",
		description: "Label for limitApplicationNumber"
	},
	"limitdetails.loanAmount": {
		id: "table.limitdetails.LoanAmount",
		defaultMessage: "Fin.beløp",
		description: "Label for loanamount"
	},
	"limitdetails.usedAmount": {
		id: "table.limitdetails.UsedAmount",
		defaultMessage: "Opptrekk",
		description: "Label for usedamount"
	},
	"limitdetails.remainingAmount": {
		id: "table.limitdetails.remainingAmount",
		defaultMessage: "Restbeløp",
		description: "Label for restamount"
	},
	"limitdetails.products": {
		id: "table.limitdetails.Products",
		defaultMessage: "Produkt",
		description: "Label for products"
	},
	"limitdetails.minEquity": {
		id: "table.limitdetails.MinEquity",
		defaultMessage: "Startleie %",
		description: "Label for min equity"
	},
	"limitdetails.objectCondition": {
		id: "table.limitdetails.ObjectCondition",
		defaultMessage: "Tilstand",
		description: "Label for object condition"
	},
	"limitdetails.terms": {
		id: "table.limitdetails.Terms",
		defaultMessage: "Løpetid",
		description: "Label for terms"
	},
	"limitdetails.vatRule": {
		id: "table.limitdetails.VatRule",
		defaultMessage: "MVA på lån",
		description: "Label for vatrule"
	},
	"limitdetails.pd": {
		id: "table.limitdetails.PD",
		defaultMessage: "PD Kunde",
		description: "Label for PD Customer"
	},
	"limitdetails.lgd": {
		id: "table.limitdetails.LGD",
		defaultMessage: "LGD Ramme",
		description: "Label for LGD Limit"
	},
	"limitdetails.lgdAmount": {
		id: "table.limitdetails.LGDAmount",
		defaultMessage: "LGD Beløp",
		description: "Label for LGD Amount"
	},
	"limitdetails.toDate": {
		id: "table.limitdetails.toDate",
		defaultMessage: "Sluttdato",
		description: "Label for to date"
	},
	"limitdetails.usedDepotValue": {
		id: "table.limitdetails.usedDepotValue",
		defaultMessage: "DV Opptrekk",
		description: "Label for used depot value"
	},
	"limitdetails.name": {
		id: "table.limitdetails.name",
		defaultMessage: "Gjenstandsgruppe",
		description: "Label for name"
	},
	"limitdetails.normalizedLoss": {
		id: "table.limitdetails.normalizedLoss",
		defaultMessage: "NT",
		description: "Label for normalizedLoss"
	},
	"limitdetails.depotValue": {
		id: "table.limitdetails.depotValue",
		defaultMessage: "DV Ramme",
		description: "Label for depotValue"
	},
	"guarantor.customerName": {
		id: "table.Guarantor.CustomerName",
		defaultMessage: "Navn",
		description: "Label for Customer Name"
	},
	"guarantor.customerNumberCombined": {
		id: "table.Guarantor.CustomerNumberCombined",
		defaultMessage: "Org.nr/Pers.nr.",
		description: "Label for Customer Number"
	},
	"guarantor.guarantorAmount": {
		id: "table.Guarantor.GuarantorAmount",
		defaultMessage: "Garantibeløp",
		description: "Label for Guarantor Amount"
	},
	"guarantor.guarantorType": {
		id: "table.Guarantor.GuarantorType",
		defaultMessage: "Garantitype",
		description: "Label for Guarantor Type"
	},
	"applications.applicationNumber": {
		id: "table.ApplicationLimitResource.ApplicationNumber",
		defaultMessage: "Søknad/Kontrakt",
		description: "Label for applicationnumber"
	},
	"applications.applicationStatus": {
		id: "table.ApplicationLimitResource.ApplicationStatus",
		defaultMessage: "Status",
		description: "Label for applicationstatus"
	},
	"applications.objectGroup": {
		id: "table.ApplicationLimitResource.objectGroup",
		defaultMessage: "Gj.gruppe",
		description: "Label for objectGroup"
	},
	"applications.objectCondition": {
		id: "table.ApplicationLimitResource.objectCondition",
		defaultMessage: "Tilstand",
		description: "Label for objectCondition"
	},
	"applications.customerAgreementId": {
		id: "table.ApplicationLimitResource.customerAgreementId",
		defaultMessage: "Ramme",
		description: "Label for customerAgreementId"
	},
	"customers.customerNumber": {
		id: "table.CUSTOMERS.customerNumber",
		defaultMessage: "Customer number",
		description: "Label for customerNumber"
	},
	"customers.customerRole": {
		id: "table.CUSTOMERS.customerRole",
		defaultMessage: "Customer role",
		description: "Label for customerRole"
	},
	"customers.customerName": {
		id: "table.CUSTOMERS.customerName",
		defaultMessage: "Customer name",
		description: "Label for customerName"
	},
	"customers.phoneMobile": {
		id: "table.CUSTOMERS.phoneMobile",
		defaultMessage: "Phone mobile",
		description: "Label for phoneMobile"
	},
	"customers.email": {
		id: "table.CUSTOMERS.email",
		defaultMessage: "Email",
		description: "Label for email"
	},
	"debts.amount": {
		id: "table.Debts.amount",
		defaultMessage: "Amount",
		description: "Label for Amount"
	},
	"debts.comment": {
		id: "table.Debts.comment",
		defaultMessage: "Comment",
		description: "Label for Comment"
	},
	"debts.creditLimit": {
		id: "table.Debts.creditLimit",
		defaultMessage: "CreditLimit",
		description: "Label for CreditLimit"
	},
	"debts.customerId": {
		id: "table.Debts.customerId",
		defaultMessage: "CustomerId",
		description: "Label for CustomerId"
	},
	"debts.lender": {
		id: "table.Debts.lender",
		defaultMessage: "Lender",
		description: "Label for Lender"
	},
	"debts.loanNumber": {
		id: "table.Debts.loanNumber",
		defaultMessage: "LoanNumber",
		description: "Label for LoanNumber"
	},
	"debts.loanType": {
		id: "table.Debts.loanType",
		defaultMessage: "LoanType",
		description: "Label for LoanType"
	},
	"debts.maturity": {
		id: "table.Debts.maturity",
		defaultMessage: "Maturity",
		description: "Label for Maturity"
	},
	"debts.nominalInterest": {
		id: "table.Debts.nominalInterest",
		defaultMessage: "NominalInterest",
		description: "Label for NominalInterest"
	},
	"debts.originalAmount": {
		id: "table.Debts.originalAmount",
		defaultMessage: "OriginalAmount",
		description: "Label for OriginalAmount"
	},
	"debts.refinance": {
		id: "table.Debts.refinance",
		defaultMessage: "Refinance",
		description: "Label for Refinance"
	},
	"debts.refinanceAmount": {
		id: "table.Debts.refinanceAmount",
		defaultMessage: "RefinanceAmount",
		description: "Label for RefinanceAmount"
	},
	"debts.source": {
		id: "table.Debts.source",
		defaultMessage: "Source",
		description: "Label for RefinanceAmount"
	},
	"debts.termAmount": {
		id: "table.Debts.termAmount",
		defaultMessage: "TermAmount",
		description: "Label for TermAmount"
	},
	"firstpropertyliens.creditorOrgNo": {
		id: "table.FIRST_PROPERTY_LIENS.creditorOrgNo",
		defaultMessage: "Creditor orgno",
		description: "Label for property creditorOrgNo"
	},
	"firstpropertyliens.creditorName": {
		id: "table.FIRST_PROPERTY_LIENS.creditorName",
		defaultMessage: "Creditor name",
		description: "Label for property creditorName"
	},
	"firstpropertyliens.registrationDate": {
		id: "table.FIRST_PROPERTY_LIENS.registrationDate",
		defaultMessage: "Registration date",
		description: "Label for property registrationDate"
	},
	"firstpropertyliens.priority": {
		id: "table.FIRST_PROPERTY_LIENS.priority",
		defaultMessage: "Priority",
		description: "Label for property priority"
	},
	"firstpropertyliens.yieldPriority": {
		id: "table.FIRST_PROPERTY_LIENS.yieldPriority",
		defaultMessage: "Yield priority",
		description: "Label for property yieldPriority"
	},
	"firstpropertyliens.documentId": {
		id: "table.FIRST_PROPERTY_LIENS.documentId",
		defaultMessage: "Document ID",
		description: "Label for property documentId"
	},
	"firstpropertyliens.value": {
		id: "table.FIRST_PROPERTY_LIENS.value",
		defaultMessage: "Value",
		description: "Label for property value"
	},
	"firstpropertyliens.writtenDownValue": {
		id: "table.FIRST_PROPERTY_LIENS.writtenDownValue",
		defaultMessage: "Written down value",
		description: "Label for property writtenDownValue"
	},
	"properties.refinance": {
		id: "table.PROPERTIES.refinance",
		defaultMessage: "Select",
		description: "Label for select property"
	},
	"properties.streetName": {
		id: "table.PROPERTIES.streetName",
		defaultMessage: "Street name",
		description: "Label for property streetName"
	},
	"properties.addressNumber": {
		id: "table.PROPERTIES.addressNumber",
		defaultMessage: "Address number",
		description: "Label for property addressNumber"
	},
	"properties.postalCode": {
		id: "table.PROPERTIES.postalCode",
		defaultMessage: "Postal code",
		description: "Label for property postalCode"
	},
	"properties.postalPlace": {
		id: "table.PROPERTIES.postalPlace",
		defaultMessage: "Postal place",
		description: "Label for property postalPlace"
	},
	"properties.municipalityNumber": {
		id: "table.PROPERTIES.municipalityNumber",
		defaultMessage: "Municipality number",
		description: "Label for property municipalityNumber"
	},
	"properties.cadastralUnitNumber": {
		id: "table.PROPERTIES.cadastralUnitNumber",
		defaultMessage: "Cadastral unit number",
		description: "Label for property cadastralUnitNumber"
	},
	"properties.unitNumber": {
		id: "table.PROPERTIES.unitNumber",
		defaultMessage: "Unit number",
		description: "Label for property unitNumber"
	},
	"properties.leaseholdUnitNumber": {
		id: "table.PROPERTIES.leaseholdUnitNumber",
		defaultMessage: "Leasehold uinit number",
		description: "Label for property leaseholdUnitNumber"
	},
	"properties.valueEnteredByCustomer": {
		id: "table.PROPERTIES.valueEnteredByCustomer",
		defaultMessage: "Override Value",
		description: "Label for property valueEnteredByCustomer"
	},
	"properties.estimatedValue": {
		id: "table.PROPERTIES.estimatedValue",
		defaultMessage: "Estimated Value",
		description: "Label for property estimatedValue"
	},
	"properties.utilizedValue": {
		id: "table.PROPERTIES.utilizedValue",
		defaultMessage: "Utilized Value",
		description: "Label for property utilizedValue"
	},
	"properties.utilizedSecurityValue": {
		id: "table.PROPERTIES.utilizedSecurityValue",
		defaultMessage: "Utilized security Value",
		description: "Label for property utilizedSecurityValue"
	},
	"properties.ownedBy": {
		id: "table.PROPERTIES.ownedBy",
		defaultMessage: "Owned By",
		description: "Label for property ownedBy"
	},
	"properties.cadastralNumber": {
		id: "table.PROPERTIES.cadastralNumber",
		defaultMessage: "Official ID",
		description: "Label for property cadastralNumber"
	},
	"properties.shareNumber": {
		id: "table.PROPERTIES.shareNumber",
		defaultMessage: "Share number",
		description: "Label for property shareNumber"
	},
	"properties.eAppraisalReference": {
		id: "table.PROPERTIES.eAppraisalReference",
		defaultMessage: "E-appraisal ref",
		description: "Label for property eAppraisalReference"
	},
	"refinanceddebts.amount": {
		id: "table.RefinancedDebts.amount",
		defaultMessage: "Amount",
		description: "Label for Amount"
	},
	"refinanceddebts.comment": {
		id: "table.RefinancedDebts.comment",
		defaultMessage: "Comment",
		description: "Label for Comment"
	},
	"refinanceddebts.creditLimit": {
		id: "table.RefinancedDebts.creditLimit",
		defaultMessage: "CreditLimit",
		description: "Label for CreditLimit"
	},
	"refinanceddebts.customerId": {
		id: "table.RefinancedDebts.customerId",
		defaultMessage: "CustomerId",
		description: "Label for CustomerId"
	},
	"refinanceddebts.lender": {
		id: "table.RefinancedDebts.lender",
		defaultMessage: "Lender",
		description: "Label for Lender"
	},
	"refinanceddebts.loanNumber": {
		id: "table.RefinancedDebts.loanNumber",
		defaultMessage: "LoanNumber",
		description: "Label for LoanNumber"
	},
	"refinanceddebts.loanType": {
		id: "table.RefinancedDebts.loanType",
		defaultMessage: "LoanType",
		description: "Label for LoanType"
	},
	"refinanceddebts.maturity": {
		id: "table.RefinancedDebts.maturity",
		defaultMessage: "Maturity",
		description: "Label for Maturity"
	},
	"refinanceddebts.nominalInterest": {
		id: "table.RefinancedDebts.nominalInterest",
		defaultMessage: "NominalInterest",
		description: "Label for NominalInterest"
	},
	"refinanceddebts.originalAmount": {
		id: "table.RefinancedDebts.originalAmount",
		defaultMessage: "OriginalAmount",
		description: "Label for OriginalAmount"
	},
	"refinanceddebts.refinance": {
		id: "table.RefinancedDebts.refinance",
		defaultMessage: "Refinance",
		description: "Label for Refinance"
	},
	"refinanceddebts.refinanceAccount": {
		id: "table.RefinancedDebts.refinanceAccount",
		defaultMessage: "Refinance Account",
		description: "Label for Refinance"
	},
	"refinanceddebts.refinanceAmount": {
		id: "table.RefinancedDebts.refinanceAmount",
		defaultMessage: "RefinanceAmount",
		description: "Label for RefinanceAmount"
	},
	"refinanceddebts.source": {
		id: "table.RefinancedDebts.source",
		defaultMessage: "Source",
		description: "Label for RefinanceAmount"
	},
	"refinanceddebts.termAmount": {
		id: "table.RefinancedDebts.termAmount",
		defaultMessage: "TermAmount",
		description: "Label for TermAmount"
	}
});
